<div class="border-b-2 sticky top-0 z-10 opacity-95">
  <p-menubar [model]="items" class="border-none" [dt]="uniqueMenubarDt">
    <ng-template #start>
      <img
        src="logo.png"
        width="40"
        [routerLink]="homeLink"
        class="cursor-pointer"
      />
    </ng-template>
    <ng-template #end>
      <div class="flex items-center gap-2">
        <button
          size="small"
          pButton
          icon="pi pi-sign-out"
          (click)="logout()"
          class="p-button-text"
        >
          <span class="hidden md:inline ml-2">Logout</span>
        </button>
      </div>
    </ng-template>
  </p-menubar>
</div>
